import { authApi } from '@mathflat/domain/Auth'
import { useQuery } from '@tanstack/react-query'

const ACADEMY_SWITCH_CANDIDATES_QUERY_KEY = ['teacher-switch-candidates']

/**
 * 전환할 수 있는 학원 목록.
 *
 * 트리거를 그리는 AcademySwitch 와 그 옆 여백을 정하는 Header 가 같은 판단을 써야 해서
 * 훅으로 묶는다. 두 곳에서 부르지만 같은 쿼리 키라 요청은 한 번만 나간다.
 */
export const useAcademySwitchCandidates = ({ enabled }: { enabled: boolean }) => {
  const { data: candidates = [], refetch } = useQuery({
    queryKey: ACADEMY_SWITCH_CANDIDATES_QUERY_KEY,
    queryFn: async () => (await authApi.getTeacherSwitchCandidates('MATHFLAT')).candidates,
    // 전환하면 페이지가 통째로 다시 뜨므로 세션 중 다시 받을 일이 없다.
    staleTime: Infinity,
    enabled,
  })

  const currentAcademy = candidates.find((candidate) => candidate.current)

  return {
    candidates,
    currentAcademy,
    // 소속이 하나인 선생님에게는 전환이 의미가 없다. 목록을 받기 전에도 false 다.
    canSwitchAcademy: candidates.length > 1 && !!currentAcademy,
    refetch,
  }
}
